import { Drawable } from "./drawable";
import { ScreenState } from "./screen";
import GroupedComponent from "./groupedComponent";
import { rgb } from "../utils/color";
import { easeOutExpo } from "easing-utils";
import { CircularButton } from "./button";

class ScoreBoard extends Drawable{
  /**
  * Initialiases the Score Board drawable.
  * @param {boolean[]} comboBarData 
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(score, maxScore, maxCombo, avgReactTime, comboBarData, exitCallback, configureCanvas){
    super(0,0, configureCanvas);
    this.score = score;
    this.maxScore = maxScore;
    this.scorePercentage = score/maxScore;
    this.maxCombo = maxCombo;
    this.avgReactTime = avgReactTime;
    this.comboBarData = comboBarData;
    this.missedWordsCount = comboBarData.filter((val) => !val).length;
    this.exitCallback = exitCallback;
    this.exitButton = new CircularButton(210+250, 60+475, 60, "Exit");
    this.exitButton.onClick = () => {
      this.exitButton.disabled = true;
      this.exitCallback()
    }
    
    // this.parsedComboData = new Array();
    // let baseCount = 0;
    // let currentComboState = comboBarData[0];
    // for (let i = 0; i < comboBarData.length; i++){
    //   if (i+1 == comboBarData.length){
    //     if (currentComboState == comboBarData[i]){
    //       baseCount++;
    //       this.parsedComboData.push(baseCount);
    //     }
    //     else{
    //       this.parsedComboData.push(baseCount);
    //       this.parsedComboData.push(1);
    //     }
    //     break;
    //   }
    //   else if (currentComboState == comboBarData[i]){
    //     baseCount++;
    //   }
    //   else{
    //     this.parsedComboData.push(baseCount);
    //     baseCount = 1
    //     currentComboState = !currentComboState;
    //   }
    // }
  }

  /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {ScreenState} screenState A positive number indicating current animation timeline
   */
  updateHover(cursors, screenState){
    const animationStep = screenState.animationStep
    const timeSinceInit = animationStep - this.initTime;
    if(timeSinceInit > 1000){
      return this.exitButton.updateHover(cursors, screenState);
    }
    return false;
  }

  // generatePraise(lang){
  //   return 'Good Job!'
  // }

  generateRankAndColour(){
    if (this.scorePercentage >= 0.85){
      return ['S', 'green']
    }
    else if (this.scorePercentage >= 0.7){
      return ['A', 'green']
    }
    else if (this.scorePercentage >= 0.6){
      return ['B', rgb(232, 170, 20)]
    }
    else if (this.scorePercentage >= 0.5){
      return ['C', rgb(232, 170, 20)]
    }
    else{
      return ['D', 'red']
    }
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){
  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    super.render(screenState);
    const timeSinceInit = screenState.animationStep - this.initTime;
    const transitionProgress = timeSinceInit <= 1000 ? easeOutExpo(timeSinceInit/1000) : screenState.transitionProgress;
    const scoreBoardComponent = new GroupedComponent(210, 60, 1060, 635, screenState);

    const scoreBoardBounding = scoreBoardComponent.rectResizeV2(0, 5, 1000, 600, transitionProgress);
    
    screenState.canvasCtx.fillStyle = rgb(108, 212, 255);
    screenState.canvasCtx.strokeStyle = rgb(228, 255, 26);
    screenState.canvasCtx.lineWidth = 8;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.roundRect(...scoreBoardBounding, [60])
    screenState.canvasCtx.fill();
    screenState.canvasCtx.stroke();
    
    const scoreBoardBoundingCenter = scoreBoardComponent.calculateCenter(...scoreBoardBounding);
    const [grade, gradeColour] = this.generateRankAndColour()
    const [gradeBoxX, gradeBoxY, gradeBoxWidth, gradeBoxHeight] = [...scoreBoardComponent.resizeXY_V2(4, 124, ...scoreBoardBoundingCenter, transitionProgress), 495*scoreBoardComponent.scaling*transitionProgress, 214*scoreBoardComponent.scaling*transitionProgress]

    screenState.canvasCtx.fillStyle = gradeColour;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.rect(gradeBoxX, gradeBoxY, gradeBoxWidth, gradeBoxHeight);
    screenState.canvasCtx.fill();


    screenState.canvasCtx.strokeStyle = rgb(255, 255, 255);
    screenState.canvasCtx.lineWidth = 10;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(0, 120, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 120, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.stroke();

    screenState.canvasCtx.lineWidth = 5;
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 120, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(500, 605, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.stroke();




    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 282, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 282, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.stroke();

    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(500, 444, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(1000, 444, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.stroke();

    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.moveTo(...scoreBoardComponent.resizeXY_V2(0, 340, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.lineTo(...scoreBoardComponent.resizeXY_V2(500, 340, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.stroke();

    // screenState.canvasCtx.setLineDash([18, 9]);
    // // screenState.canvasCtx.lineDashOffset = 20;
    // screenState.canvasCtx.lineDashOffset = -(screenState.animationStep/50 % 27);
    // screenState.canvasCtx.fillStyle = gradeColour;
    // screenState.canvasCtx.beginPath();
    const [gradeBoxCenterX, gradeBoxCenterY] = scoreBoardComponent.resizeXY_V2(252, 231, ...scoreBoardBoundingCenter, transitionProgress)
    // screenState.canvasCtx.arc(gradeBoxX, gradeBoxY, screenState.S(90*transitionProgress), 0, 2*Math.PI);
    // screenState.canvasCtx.fill();
    // screenState.canvasCtx.stroke();
    // screenState.canvasCtx.setLineDash([]);
    // screenState.canvasCtx.lineDashOffset = 0;
    screenState.canvasCtx.font = `bold ${screenState.S(30*transitionProgress)}px Yusei Magic`
    const gradeLabelMetrics = screenState.canvasCtx.measureText('Rank')
    const gradeLabelHeight = gradeLabelMetrics.actualBoundingBoxAscent + gradeLabelMetrics.actualBoundingBoxDescent;
    screenState.canvasCtx.font = `bold ${screenState.S(100*transitionProgress)}px Yusei Magic`
    const gradeMetrics = screenState.canvasCtx.measureText(grade)
    const gradeHeight = gradeMetrics.actualBoundingBoxAscent + gradeMetrics.actualBoundingBoxDescent;
    screenState.canvasCtx.fillStyle = rgb(255, 255, 255);
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(grade, gradeBoxCenterX, gradeBoxCenterY-gradeLabelHeight/2);
    screenState.canvasCtx.font = `bold ${screenState.S(30*transitionProgress)}px Yusei Magic`
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText('Rank', gradeBoxCenterX, gradeBoxCenterY+gradeLabelHeight/2 + gradeHeight/2);
    
    screenState.canvasCtx.font = `bold ${screenState.S(72*transitionProgress)}px Yusei Magic`
    // screenState.canvasCtx.fillStyle = rgb(255, 255, 255);
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(`${this.score}/${this.maxScore} (${Math.round(this.scorePercentage*100)}%)`, ...scoreBoardComponent.resizeXY_V2(500, 60, ...scoreBoardBoundingCenter, transitionProgress));
    


    screenState.canvasCtx.font = `bold ${screenState.S(36*transitionProgress)}px Yusei Magic`
    screenState.canvasCtx.textAlign = 'left';
    screenState.canvasCtx.textBaseline = 'top';
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "最大コンボ" : "Max Combo", ...scoreBoardComponent.resizeXY_V2(510, 130, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "ミス" : "Missed", ...scoreBoardComponent.resizeXY_V2(510, 288, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(screenState.lang == 'jp' ? "平均反応時間" : "Avg. Response Time", ...scoreBoardComponent.resizeXY_V2(510, 450, ...scoreBoardBoundingCenter, transitionProgress));
    // screenState.canvasCtx.textAlign = 'center';
    // screenState.canvasCtx.textBaseline = 'middle';
    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.fillText(this.generatePraise('en'), ...scoreBoardComponent.resizeXY_V2(800, 585, ...scoreBoardBoundingCenter, transitionProgress));
    // screenState.canvasCtx.beginPath();
    // screenState.canvasCtx.fillText('Combo Bar', ...scoreBoardComponent.resizeXY_V2(310, 285, ...scoreBoardBoundingCenter, transitionProgress));
    
    screenState.canvasCtx.font = `${screenState.S(60*transitionProgress)}px Yusei Magic`;
    // screenState.canvasCtx.textAlign = 'right';
    screenState.canvasCtx.textBaseline = 'top';
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(this.maxCombo, ...scoreBoardComponent.resizeXY_V2(510, 180, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(this.missedWordsCount, ...scoreBoardComponent.resizeXY_V2(510, 338, ...scoreBoardBoundingCenter, transitionProgress));
    screenState.canvasCtx.beginPath();
    screenState.canvasCtx.fillText(`${(Math.round(this.avgReactTime*10)/10).toString().replace('.', '.\u2005')}ms`, ...scoreBoardComponent.resizeXY_V2(510, 500, ...scoreBoardBoundingCenter, transitionProgress));
    
    [this.exitButton.overrideXpos, this.exitButton.overrideYpos] = scoreBoardComponent.resizeXY_V2(250, 475, ...scoreBoardBoundingCenter, transitionProgress)
    this.exitButton.overrideTransitionProgress = transitionProgress;
    this.exitButton.text = screenState.lang == 'jp' ? '終了' : 'Exit'; 
    this.exitButton.render(screenState);

  }
}

export default ScoreBoard;